// extracted by mini-css-extract-plugin
export default {"container":"DefaultTemplate_container__6RDFG","main":"DefaultTemplate_main__0XxBw"};